export interface SsrState {
    isSSR: boolean;
}

export const initialState: SsrState = {
    isSSR: false,
};



// WEBPACK FOOTER //
// ./src/store/SsrState.ts